import styled, { css } from 'styled-components';
import { EmptyCartIllustration } from './EmptyCartIllustration';

const textStyles = css`
    padding: 0 32px;
    text-align: center;
    color: ${({ theme }) => theme.colors.Foreground};
`;

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

const Image = styled(EmptyCartIllustration)`
    height: 200px;
    width: 200px;
    margin-bottom: 16px;
`;

const Header = styled.h3`
    ${({ theme }) => css(theme.typography.SmallHeadline)};
    ${textStyles};
    margin-bottom: 8px;
`;

const Description = styled.p`
    ${({ theme }) => css(theme.typography.Paragraph)};
    ${textStyles};
`;

export {
    Wrap, Image, Header, Description,
};
